import { DefaultTheme } from 'styled-components';

import { BORDER_WIDTH, BORDER_WIDTH_IMAGE, BORDER_WIDTH_OUTLINED } from './constants';
import { ContentCardPadding, ContentCardVariant } from './types';

const getPadding = (padding: ContentCardPadding) => {
  switch (padding) {
    case ContentCardPadding.None:
      return 0;
    case ContentCardPadding.Small:
      return 1;
    case ContentCardPadding.Medium:
      return 2;
    case ContentCardPadding.Large:
      return 3;
    default:
      return 2;
  }
};

// An offset is necessary to keep the contents of the card aligned
// regardless of the border thickness
const getBorderOffset = (variant: ContentCardVariant) => {
  switch (variant) {
    case ContentCardVariant.Outlined:
      return BORDER_WIDTH_OUTLINED - BORDER_WIDTH;
    case ContentCardVariant.Dashed:
      return BORDER_WIDTH_IMAGE - BORDER_WIDTH;
    default:
      return 0;
  }
};

export const getPaddingObject = (
  theme: DefaultTheme,
  variant: ContentCardVariant,
  padding: ContentCardPadding
) => {
  const paddingValue = getPadding(padding);
  return {
    top: `calc(${theme.spacing(1.5 * paddingValue)} - ${getBorderOffset(variant)}px)`,
    bottom: `calc(${theme.spacing(1.5 * paddingValue)} - ${getBorderOffset(variant)}px)`,
    left: `calc(${theme.spacing(2 * paddingValue)} - ${getBorderOffset(variant)}px)`,
    right: `calc(${theme.spacing(2 * paddingValue)} - ${getBorderOffset(variant)}px)`,
  };
};

export const getVariantEnum = (variant?: string) => {
  switch (variant) {
    case 'contained':
    case 'outlined':
    case 'paper':
    case 'dashed':
      return variant as ContentCardVariant;
    default:
      return ContentCardVariant.Contained;
  }
};

export const getPaddingEnum = (padding?: string) => {
  switch (padding) {
    case 'none':
    case 'small':
    case 'medium':
    case 'large':
      return padding as ContentCardPadding;
    default:
      return ContentCardPadding.Medium;
  }
};
